import { DeviceView } from "fleet/controller/device-view";
import {
  LOAD_DEVICE_STATS,
  unloadDeviceStatsAction,
} from "fleet/redux-store/ui-state/device-stats/actions";
import { deviceStatsSelector } from "fleet/redux-store/ui-state/device-stats/selectors";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getAuthUser } from "redux-store/auth";
import { deviceStatusesSelector } from "redux-store/device-statuses/selectors";
import { CLEAR_CACHE, CLEAR_WEBCAM_SNAPSHOT_CACHE, RESTART_DEVICE } from "redux-store/devices/actions";
import { defaultObject } from "redux-store/selectors";
import { currentDeviceSelector } from "redux-store/ui-state/current-device/selectors";
import { storesReady } from "redux-store/utils";
import { withFetchDeviceController } from "ui/fetch";
import * as FeatureFlags from 'redux-store/feature-flags/selectors';

function mapStateToProps(state, props) {
  const { activeTab, id: deviceId } = props.match.params || {};

  const storesLoaded = storesReady(state.global.devices);

  const device = currentDeviceSelector(state);
  const devicePk = (device || {}).id;
  const deviceStatuses = deviceStatusesSelector(state);
  const deviceStatus = deviceStatuses[devicePk] || defaultObject;
  const isThirdParty = (device && device.is_thirdparty) || false;
  const user = getAuthUser(state);
  const featureFlags = FeatureFlags.getFeatureFlags(state);

  return {
    activeTab,
    device,
    deviceId,
    deviceStatus,
    featureFlags,
    isThirdParty,
    storesLoaded,
    user,
    stats: deviceStatsSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearPlayerCache: (deviceId) => {
      return createPromiseApiAction(dispatch, CLEAR_CACHE, [deviceId]);
    },
    clearWebcamSnapshotCache: (deviceId) => {
      return createPromiseApiAction(dispatch, CLEAR_WEBCAM_SNAPSHOT_CACHE, [deviceId]);
    },
    loadDeviceStats: (deviceId) => {
      return createPromiseApiAction(dispatch, LOAD_DEVICE_STATS, [deviceId]);
    },
    unloadDeviceStats: () => {
      dispatch(unloadDeviceStatsAction);
    },
    restartDevice: (deviceId) => {
      return createPromiseApiAction(dispatch, RESTART_DEVICE, [deviceId]);
    },
  };
}

const withFetch = withFetchDeviceController(DeviceView);
const ConnectedDeviceView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFetch);

export { ConnectedDeviceView };
